import { Categories } from "@/@types";
import { CategoriesResponse } from "../../partsServices/models/PartsServicesResponse";

export function mapCategories(categories: CategoriesResponse): Categories {

  return categories.map((cat) => ({
    name: cat.name,
    slug: cat.slug,
    icon: cat.icon,
    description: cat.description,
    subcategories: cat.subcategories.map((subcategory) => ({
      name: subcategory.name,
      slug: subcategory.slug,
    })),
  }));
}